import { Portal as _Portal } from "@chakra-ui/react";

export const Portal = _Portal;
